"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('steps');
const Steps = (props) => {
    const { direction = 'horizontal', current = 0, steps, status } = props;
    const statusIconType = status === 'error' ? 'roundclosefill' : 'roundcheckfill';
    const statusIconColor = status === 'error' ? '#f5222d' : '#1890FF';
    const getTitle = (item, index) => {
        if (index === current) {
            if (status === 'error') {
                return item.errorTitle || item.title;
            }
        }
        return item.title;
    };
    if (direction === 'vertical') {
        return (React.createElement(one_1.View, { className: prefixCls }, steps === null || steps === void 0 ? void 0 : steps.map((item, index) => (React.createElement(one_1.View, { key: index, className: `${prefixCls}-step` },
            index === 0 ? (React.createElement(one_1.View, { className: `${prefixCls}-circle_current` },
                React.createElement(one_1.Text, { className: `${prefixCls}-circle_current-icon` },
                    React.createElement(icon_1.default, { type: "roundcheckfill", size: "40px", color: "#1890FF" })))) : (React.createElement(one_1.View, { className: `${prefixCls}-circle` })),
            React.createElement(one_1.View, { className: `${prefixCls}-line` }),
            React.createElement(one_1.View, { className: `${prefixCls}-step-header` },
                React.createElement(one_1.View, { className: `${prefixCls}-step-header-title` }, item.title),
                React.createElement(one_1.View, { className: `${prefixCls}-step-header-extra` }, item.extra)),
            React.createElement(one_1.View, { className: `${prefixCls}-step-description` }, item.description))))));
    }
    return (React.createElement(one_1.View, { className: `${prefixCls}_horizontal` }, steps === null || steps === void 0 ? void 0 : steps.map((item, index) => (React.createElement(one_1.View, { key: index, className: classnames_1.default({
            [`${prefixCls}_horizontal-step`]: true,
            [`${prefixCls}_horizontal-step-finish`]: index <= current - 1,
        }) },
        React.createElement(one_1.View, { className: `${prefixCls}_horizontal-step-container` },
            React.createElement(one_1.View, { className: `${prefixCls}_horizontal-step-container-icon` },
                index < current ? React.createElement(icon_1.default, { type: "roundcheckfill", size: "40px", color: "#1890FF" }) : null,
                index === current ? (React.createElement(icon_1.default, { type: statusIconType, size: "40px", color: statusIconColor })) : null,
                index > current ? (React.createElement(one_1.View, { className: `${prefixCls}_horizontal-step-container-icon-default` },
                    React.createElement(one_1.View, null))) : null),
            React.createElement(one_1.View, { className: `${prefixCls}_horizontal-step-container-content` },
                React.createElement(one_1.View, { className: `${prefixCls}_horizontal-step-container-content-title` }, getTitle(item, index)))))))));
};
exports.default = Steps;
